export default function getResource(label) {
    const resources = {
        itemsInOrder: 'Articles de la commande',
        itemInOrder: 'Article de la commande',
        sameDayDeliveryItems: 'Articles pour livraison le jour même',
        fastDeliveryItems: 'Articles pour livraison rapide'
    };

    return resources[label];
}
